import script from "./ChartCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartCard.vue?vue&type=script&setup=true&lang=js"

import "./ChartCard.vue?vue&type=style&index=0&id=55ff674c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55ff674c"]])

export default __exports__